import { nextTick, ref } from "vue";
import CommonApi from './index';
import TaskQueue from "./TaskQueue";
import fetchFUN from './requset'
import encrypt from '@/utils/crypto-util';
//导入pinia
import { useNewpageData } from "../stroe/pinia";
let NewpageData: any
//dom更新后执行
nextTick(() => {
    NewpageData = useNewpageData();
})
//单次错误最大错误条数
let max = 20
//创建Map实例 重复错误标识去重
// let ErrAarry = new Map()
//创建任务队列实例
const taskQueue = new TaskQueue();
//报错存储数组
let errorarr: any = []
//全部本地存储
let allmeerror: any = []
//本地set数组
let errorSet = new Set()
//生成报错唯一标识符
const Unicodefun = (str: string) => {
    // return Array.from(str).map(char => String.fromCharCode(char.charCodeAt(0) - 3)).join('');
    return encrypt.md5(str)
}
//以保存的错误记录 map数组
let oldmap = new Map()
//计数
let arrnum: any = 0
//定时器
let timer: any
//获取当天时间戳
const getdate = () => {
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfDayTimestamp = startOfDay.getTime();
    console.log(startOfDayTimestamp, '输出当天时间戳');
    return startOfDayTimestamp
}
let nowtime = getdate()
// 上传错误 上传成功删除已经上传的数组
let updataerror = (type: any, data: any) => {
    return new Promise(async (resolve, reject) => {
        try {
            let res: any = await fetchFUN(type, data)
            let dataseta: any = new Set([...data]);
            if (res.status == 1) {
                //上传成功 删除当前数组的数据
                console.log(res.msg);
                console.log(allmeerror, '全部对象', data, '需要删除对象', dataseta, 'set对象');
                allmeerror = allmeerror.filter((item: any) => !dataseta.has(item));
                console.log(allmeerror, '删除后剩余数组');
                resolve(true)
            }
        } catch (error) {
        }
    })
}
//是否添加报错记录新旧对比
const Addset = (code: any, data: any, nowtime: any) => {
    if (timer) {
        clearInterval(timer)
    }
    if (NewpageData.ErrorSet.size > 0) {
        if (NewpageData.ErrorSet.size > errorSet.size) {
            console.warn('本地有错误记录 从pina中取出与目前合并 本地大于现在 ', NewpageData.ErrorSet);
            errorSet = new Set([...errorSet, ...NewpageData.ErrorSet]);
        }
    }
    if (errorSet.has(code)) {
        console.log('已存在或者已上传', code, errorSet, nowtime);
    } else {
        //总收集数
        if (errorarr.length <= 3) {
            errorSet.add(code)
            errorarr.push(data)
            allmeerror.push(data)
            console.log('新添加', errorarr, code, errorSet);
            timer = setInterval(() => {
                arrnum++
                console.log(`倒计时${arrnum}`);
                if (arrnum >= 5) {
                    clearInterval(timer)
                    console.log('已超过5s未报错,进行上传');
                    taskQueue.addQueue(() => updataerror('error', errorarr))
                }
            }, 1000)
        } else {
            allmeerror.push(data)
            errorSet.add(code)
            taskQueue.addQueue(() => updataerror('error', errorarr))
            clearInterval(timer)
            arrnum = 0
            errorarr = []
            errorarr.push(data)
            console.log('上一波结束 下一波开始');
        }
        console.log(allmeerror, '添加过后数组');
        let SetArr = Array.from(errorSet)
        localStorage.setItem('erarr', `${nowtime}——` + JSON.stringify(SetArr))
    }
}
//资源报错计数  总体资源报错 超过十个停止上报 代表服务器存储资源出了问题
let reserror_count = 0
//页面不处于激活状态时，存储未发送报错
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
        if (allmeerror.length > 0) {
            console.log('页面不处于激活状态时，存储未发送报错');
            localStorage.setItem('olderror', JSON.stringify(allmeerror))
        }
    }
})
export default {
    //代码报错
    async errorHandler(err: any) {
        console.log('触发errorHandler', err);
        let strone = String(`${err.message}+${err.filename}+${err.colno}+${err.lineno}`)
        let newstr = Unicodefun(strone)
        console.log(newstr);
        Addset(newstr, {
            'type': 'codeerror',
            '报错信息': err.message,
            '引发错误的脚本的URL': err.filename,
            '发生错误的行号': err.lineno,
            '发生错误的行的列号': err.colno,
            '错误对象': err.error,
            '特征码': newstr,
        }, nowtime)
    },
    //vue组件报错
    async vueerrorHandler(err: any) {
        console.log('触发errorHandler', err);
        let strone = String(`${err.message}+${err.instance}+${err.info}`)
        let newstr = Unicodefun(strone)
        console.log(newstr);
        Addset(newstr, {
            'type': 'vuecodeerror',
            '报错信息': err.message,
            '错误组件': err.instance,
            '错误所在生命周期': err.info,
            '特征码': newstr,
        }, nowtime)
    },
    //资源报错
    async resourceerror(err: any) {
        console.log('触发resourceerror', err);
        let strone = String(`${err.target.dataset.gid}+${err.target.dataset.gname}+${err.target.dataset.src}`)
        let newstr = Unicodefun(strone)
        console.log(strone);
        console.log(newstr);
        reserror_count++
        if (reserror_count <= 10) {
            console.log('第' + reserror_count + '次资源报错');
            Addset(newstr, {
                'type': 'reserror',
                '游戏id': err.target.dataset.gid,
                '游戏名称': err.target.dataset.gname,
                '图片地址': err.target.dataset.src,
                '特征码': newstr,
            }, nowtime)
        } else {
            console.log('资源报错超过10个 停止上报');
            return
        }
    },
    //script资源报错
    async scripterror(err: any) {
        console.log('触发scripterror', err);
        let strone = String(`JavaScript${err.target.src}`)
        let newstr = Unicodefun(strone)
        console.log(strone);
        console.log(newstr);
        Addset(newstr, {
            'type': 'reserror',
            '地址': err.target.src,
            '特征码': newstr,
        }, nowtime)
    },
    //接口报错
    async onerror(err: any) {
        console.log('触发接口报错onerror', err);
        let strone = String(`send${err.errorSend}+${err.errorurl}+${err.error}`)
        let newstr = Unicodefun(strone)
        console.log(strone);
        console.log(newstr);
        Addset(newstr, {
            'type': 'sendrror',
            '发送数据': err.errorSend,
            '发送地址': err.errorurl,
            '报错信息': err.error,
            '特征码': newstr,
        }, nowtime)
    },
}